import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1a84675c from 'nuxt_plugin_plugin_1a84675c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_axios_db3c871c from 'nuxt_plugin_axios_db3c871c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_02b4dd0e from 'nuxt_plugin_workbox_02b4dd0e' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_00c193be from 'nuxt_plugin_metaplugin_00c193be' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_moment_6efd3934 from 'nuxt_plugin_moment_6efd3934' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_fontawesome_d2eb1280 from 'nuxt_plugin_fontawesome_d2eb1280' // Source: ../plugins/fontawesome (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_JSONToCSVConvertor_6febb187 from 'nuxt_plugin_JSONToCSVConvertor_6febb187' // Source: ../plugins/JSONToCSVConvertor (mode: 'all')
import nuxt_plugin_commonMethods_76f661d3 from 'nuxt_plugin_commonMethods_76f661d3' // Source: ../plugins/commonMethods (mode: 'all')
import nuxt_plugin_telematics_12d2a657 from 'nuxt_plugin_telematics_12d2a657' // Source: ../plugins/telematics (mode: 'all')
import nuxt_plugin_map_caea8a30 from 'nuxt_plugin_map_caea8a30' // Source: ../plugins/map (mode: 'all')
import nuxt_plugin_regex_230fd2d3 from 'nuxt_plugin_regex_230fd2d3' // Source: ../plugins/regex (mode: 'all')
import nuxt_plugin_crisp_67db6a58 from 'nuxt_plugin_crisp_67db6a58' // Source: ../plugins/crisp.js (mode: 'client')
import nuxt_plugin_plugin_381ba7a4 from 'nuxt_plugin_plugin_381ba7a4' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"fleetch","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"hid":"charset","charset":"utf-8"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Fleetch"},{"hid":"theme-color","name":"theme-color","content":"#676AC3"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Fleetch"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Fleetch"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Fleet Management made easy"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ficons\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto|Raleway|Pacifico&display=swap"},{"hid":"shortcut-icon","rel":"shortcut icon","href":"\u002Ficons\u002Ficon-192x192.png"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","href":"\u002Ficons\u002Ficon-512x512.png","sizes":"512x512"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.6adc42d6.json","hid":"manifest"}],"script":[{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fmg-api-js"},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fgoogle-palette\u002F1.1.0\u002Fpalette.js"}],"style":[],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1a84675c === 'function') {
    await nuxt_plugin_plugin_1a84675c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_db3c871c === 'function') {
    await nuxt_plugin_axios_db3c871c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_02b4dd0e === 'function') {
    await nuxt_plugin_workbox_02b4dd0e(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_00c193be === 'function') {
    await nuxt_plugin_metaplugin_00c193be(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_6efd3934 === 'function') {
    await nuxt_plugin_moment_6efd3934(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_d2eb1280 === 'function') {
    await nuxt_plugin_fontawesome_d2eb1280(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_JSONToCSVConvertor_6febb187 === 'function') {
    await nuxt_plugin_JSONToCSVConvertor_6febb187(app.context, inject)
  }

  if (typeof nuxt_plugin_commonMethods_76f661d3 === 'function') {
    await nuxt_plugin_commonMethods_76f661d3(app.context, inject)
  }

  if (typeof nuxt_plugin_telematics_12d2a657 === 'function') {
    await nuxt_plugin_telematics_12d2a657(app.context, inject)
  }

  if (typeof nuxt_plugin_map_caea8a30 === 'function') {
    await nuxt_plugin_map_caea8a30(app.context, inject)
  }

  if (typeof nuxt_plugin_regex_230fd2d3 === 'function') {
    await nuxt_plugin_regex_230fd2d3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_crisp_67db6a58 === 'function') {
    await nuxt_plugin_crisp_67db6a58(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_381ba7a4 === 'function') {
    await nuxt_plugin_plugin_381ba7a4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
